// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagify-wrapper {
  flex: 1;
}
.tagify-wrapper .tagify-button-group .tagify-button {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  border-style: none;
  background-color: transparent;
  padding: 0;
  position: relative;
  cursor: pointer;
}
.tagify-wrapper .tagify-button-group .tagify-button.select-all-buton {
  text-decoration: underline;
}
.tagify-wrapper .tagify-button-group .tagify-button.remove-all-button {
  border-left: 1px solid #D8D9DB;
  padding-left: 13px;
  margin-left: 13px;
}`, "",{"version":3,"sources":["webpack://./src/components/TagInput/TagInput.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;AACJ;AACQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AACZ;AAAY;EACI,0BAAA;AAEhB;AAAY;EACI,8BAAA;EACA,kBAAA;EACA,iBAAA;AAEhB","sourcesContent":[".tagify-wrapper {\n    flex: 1;\n    .tagify-button-group {\n        .tagify-button {\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 20px;\n            border-style: none;\n            background-color: transparent;\n            padding: 0;\n            position: relative;\n            cursor: pointer;\n            &.select-all-buton {\n                text-decoration: underline;\n            }\n            &.remove-all-button {\n                border-left: 1px solid #D8D9DB;\n                padding-left: 13px;\n                margin-left: 13px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
